import { render, staticRenderFns } from "./detail_six.vue?vue&type=template&id=b4370eb0&scoped=true&"
import script from "./detail_six.vue?vue&type=script&lang=js&"
export * from "./detail_six.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4370eb0",
  null
  
)

export default component.exports